'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../../_virtual/index.cjs');

/**
 * SVG Illustration of track order mobile
 */ const TrackOrderMobile = ({ assetColor = index.cjsExports.ASSET_COLORS.grey, size = index.cjsExports.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 104",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52",
                r: "52",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "43.3984",
                y: "68.6973",
                width: "17.4267",
                height: "5.17625",
                rx: "2.33602",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.909 19H63.1865C64.8049 19.009 66.3542 19.6569 67.497 20.8028C68.6398 21.9486 69.2836 23.4996 69.288 25.1178V78.4869C69.2836 80.1081 68.6375 81.6615 67.491 82.8079C66.3445 83.9542 64.7908 84.6002 63.1695 84.6047H40.892C39.2706 84.6002 37.717 83.9542 36.5705 82.8079C35.424 81.6615 34.7779 80.1081 34.7734 78.4869V66.7484V59.1935V57.3381V25.1178C34.7779 23.4937 35.4263 21.9376 36.5765 20.7908C37.7266 19.644 39.2847 19 40.909 19Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M58.6015 68.7773H45.4891C44.0928 68.7773 42.9609 69.9091 42.9609 71.3052C42.9609 72.7013 44.0928 73.833 45.4891 73.833H58.6015C59.9978 73.833 61.1296 72.7013 61.1296 71.3052C61.1296 69.9091 59.9978 68.7773 58.6015 68.7773Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "49.1445",
                y: "73.834",
                width: "5.98901",
                height: "5.85592",
                rx: "2.92796",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "37.4336",
                y: "21.9277",
                width: "29.4127",
                height: "48.4444",
                rx: "2.86482",
                fill: theme.ds5.asset[assetColor]["300"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M52.4802 35.2159C53.8267 35.2159 54.9189 36.308 54.9189 37.6546C54.9189 39.0011 53.8267 40.0929 52.4802 40.0929C51.1336 40.0929 50.0415 39.0011 50.0415 37.6546C50.0415 36.308 51.1329 35.2159 52.4802 35.2159ZM52.4802 33.168C49.6558 33.168 47.3797 35.4398 47.375 38.2641C47.3731 39.447 47.7736 40.5364 48.4472 41.4027C48.9337 42.0283 49.4143 42.6585 49.8844 43.2966C50.0747 43.5553 50.2638 43.8156 50.4502 44.0774C50.6155 44.3083 50.7785 44.5408 50.9394 44.7745L51.2587 45.2379L51.8139 46.0448L52.4841 47.0178L53.1519 46.0456L53.706 45.2391L54.0229 44.7784C54.1842 44.5435 54.348 44.3099 54.5133 44.0777C54.6992 43.8159 54.888 43.5557 55.0783 43.297C55.5495 42.6562 56.0321 42.0232 56.519 41.3941C57.1868 40.5313 57.5846 39.4485 57.5846 38.2724C57.5849 35.4539 55.2994 33.168 52.4802 33.168Z",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M57.0012 44.2838C56.6456 44.0208 56.2564 43.7922 55.8407 43.6008C55.6594 43.8462 55.4749 44.0986 55.2905 44.3557C55.7133 44.5351 56.1056 44.757 56.4581 45.018C57.4756 45.7706 58.0359 46.7584 58.0359 47.799C58.0359 48.8396 57.4756 49.827 56.4581 50.5796C55.3995 51.3631 53.985 51.7941 52.4744 51.7941C50.9637 51.7941 49.5492 51.3631 48.4903 50.5796C47.4731 49.827 46.9128 48.8396 46.9128 47.799C46.9128 46.7584 47.4731 45.7706 48.4903 45.018C48.8443 44.7566 49.2382 44.5343 49.6617 44.3542C49.4867 44.1103 49.3038 43.8595 49.1108 43.5996C48.6942 43.7915 48.3039 44.0201 47.9471 44.2838C46.6916 45.2134 46 46.4615 46 47.799C46 49.1366 46.6916 50.3846 47.9475 51.3138C49.1627 52.2126 50.7703 52.7072 52.4748 52.7072C54.1792 52.7072 55.7868 52.2126 57.0012 51.3138C58.2571 50.3846 58.9491 49.1366 58.9491 47.799C58.9491 46.4615 58.2571 45.2134 57.0012 44.2838Z",
                fill: theme.ds5.asset[assetColor]["500"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M54.9183 45.8196C54.7761 45.7145 54.6241 45.6196 54.4639 45.5352L53.9422 46.2948C54.097 46.369 54.2423 46.4558 54.3756 46.5538C54.8355 46.8942 55.0887 47.3338 55.0887 47.7914C55.0887 48.2489 54.8351 48.6889 54.3756 49.0289C53.8739 49.3997 53.2002 49.6041 52.4777 49.6041C51.7552 49.6041 51.0815 49.3997 50.5798 49.0289C50.1199 48.6889 49.8663 48.2493 49.8663 47.7914C49.8663 47.3334 50.1199 46.8942 50.5798 46.5538C50.7142 46.4542 50.8612 46.3671 51.0182 46.2924L50.495 45.5332C50.3337 45.618 50.1801 45.7133 50.0367 45.8196C49.3376 46.3366 48.9531 47.0368 48.9531 47.7914C48.9531 48.5459 49.3376 49.2461 50.0367 49.7627C50.6943 50.2492 51.561 50.5172 52.4773 50.5172C53.3936 50.5172 54.2603 50.2492 54.9179 49.7627C55.6166 49.2461 56.0011 48.5455 56.0011 47.7914C56.0011 47.0372 55.6166 46.3366 54.9179 45.8196H54.9183Z",
                fill: theme.ds5.asset[assetColor]["500"]
            })
        ]
    });
};

exports.TrackOrderMobile = TrackOrderMobile;
//# sourceMappingURL=TrackOrderMobile.cjs.map
